import { features } from 'reactApp/mail-features';

interface MultiSessionRestriction {
    enabled: boolean;
    limit: number;
    max_bot_url: string;
    modal: {
        closable: boolean;
        disable_tariffs_button: boolean;
    };
    qr: {
        trk_enabled: boolean;
        trk_url: string;
        max_logo_enabled: boolean;
    };
}

const defaultConfig: MultiSessionRestriction = {
    enabled: false,
    limit: 3,
    max_bot_url: 'https://max.ru/mailru_admin_bot',
    modal: {
        closable: true,
        disable_tariffs_button: false,
    },
    qr: {
        trk_enabled: true,
        trk_url: 'https://trk.mail.ru/c/wmepk3',
        max_logo_enabled: false,
    },
};

export const multiSessionRestrictionConfig: MultiSessionRestriction = features.getAsJSONWithDefaults(
    'multi-session-restriction-config',
    defaultConfig
);
